import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { IconProps } from './types'

const WhatsappIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props

  return (
    <SvgIcon viewBox="0 0 24 24" style={{ color, fontSize, ...style }} {...rest}>
      <path d="M6.37,17.41a.9.9,0,0,0-.24.61.88.88,0,0,0,.25.61.83.83,0,0,0,1.21,0,.86.86,0,1,0-1.22-1.22Zm1,1Z" />
      <path d="M19.51,7.48A.77.77,0,0,0,18.93,7a.83.83,0,0,0-.74.25L16.1,9.42h-.76a.11.11,0,0,1-.1-.12V8.51a.1.1,0,0,1,0-.09l2-2.12a.87.87,0,0,0,.23-.75A.78.78,0,0,0,17.1,5a5,5,0,0,0-2.23-.53A5.27,5.27,0,0,0,9.71,9.8a5.17,5.17,0,0,0,.12,1.11.15.15,0,0,1,0,.15l-5,5.23a2.91,2.91,0,0,0-.8,2,2.79,2.79,0,0,0,2.74,2.84,2.64,2.64,0,0,0,1.94-.83l5-5.23a.11.11,0,0,1,.11,0,4.83,4.83,0,0,0,1.08.12A5.27,5.27,0,0,0,20,9.8,5.45,5.45,0,0,0,19.51,7.48Zm-4.64,5.93a3.53,3.53,0,0,1-.72-.08,1.8,1.8,0,0,0-1.69.51l-5,5.23a1,1,0,0,1-.73.32,1.06,1.06,0,0,1-1-1.1A1.13,1.13,0,0,1,6,17.51l5-5.22a2,2,0,0,0,.49-1.74,3.19,3.19,0,0,1-.08-.75,3.54,3.54,0,0,1,3.45-3.61H15l-1,1a1.89,1.89,0,0,0-.52,1.32V9.3a1.84,1.84,0,0,0,1.8,1.87h.76a1.77,1.77,0,0,0,1.28-.55l.93-1V9.9A3.53,3.53,0,0,1,14.87,13.41Z" />{' '}
    </SvgIcon>
  )
}
export default WhatsappIcon
